export const ALARM = "alarm/LIST";

export const setAlarm = ({ alarmList }) => ({
	type: ALARM,
	payload: {
		alarmList,
	},
});
